import React from "react";

import { classList } from "../../lib/helpers";
import * as styles from "./Badge.module.scss";

export type BadgeData = {
  text?: string;
  backgroundColor?: { title: string; value: string };
};

export interface BadgeProps {
  data: BadgeData;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  className,
  data: { text, backgroundColor = { title: "yellow" } },
}) => {
  const classes = classList(
    styles.badge,
    styles["badge_" + backgroundColor.title],
    className && className
  );

  return <div className={classes}>{text}</div>;
};
